import { Edit } from '@material-ui/icons';
import { Grid, IconButton } from '@material-ui/core';
import { IQuestionItem } from 'pages/formsCreate/types';
import React from 'react';
import { useEditFormContext } from 'pages/formsCreate/context';

type Props = {
  item: IQuestionItem;
};

export const ManageQuestion = ({ item }: Props) => {
  const { setSeletectedQuestion } = useEditFormContext();

  const handleOpenModal = () => {
    setSeletectedQuestion(item);
  };

  return (
    <Grid item>
      <IconButton type="button" onClick={handleOpenModal} size="small">
        <Edit fontSize="small" />
      </IconButton>
    </Grid>
  );
};
